import { createSlice } from '@reduxjs/toolkit'
import { getActiveFilters } from 'utils/helpers'

const initialState = {
  activeFilters: [] as string[],
  tableFilters: {
    search: '',
    group: '',
    course: '',
    grade_level: '',
    reporter: '',
    student: '',
    start_date_from: '',
    start_date_before: '',
    status: '',
  },
}

export const attendanceUI = createSlice({
  name: 'attendanceUI',
  initialState: initialState,
  reducers: {
    setSearch: (state, { payload }) => {
      state.tableFilters.search = payload
    },
    setGroup: (state, { payload }) => {
      state.tableFilters.group = payload
    },
    setGradeLevel: (state, { payload }) => {
      state.tableFilters.grade_level = payload
    },
    setCourse: (state, { payload }) => {
      state.tableFilters.course = payload
    },
    setReporter: (state, { payload }) => {
      state.tableFilters.reporter = payload
    },
    setStudent: (state, { payload }) => {
      state.tableFilters.student = payload
    },
    setStatus: (state, { payload }) => {
      state.tableFilters.status = payload
    },
    setStartDateFrom: (state, { payload }) => {
      state.tableFilters.start_date_from = payload
    },
    setStartDateBefore: (state, { payload }) => {
      state.tableFilters.start_date_before = payload
    },
    trackActiveFilters: (state: any) => {
      state.activeFilters = getActiveFilters(initialState.tableFilters, state)
    },
    clearAllFilters: (state: any) => {
      state.tableFilters = initialState.tableFilters
      state.activeFilters = []
    },
  },
})

export const {
  setSearch,
  setGroup,
  setGradeLevel,
  setCourse,
  setReporter,
  setStudent,
  setStatus,
  setStartDateFrom,
  setStartDateBefore,
  trackActiveFilters,
  clearAllFilters,

} = attendanceUI.actions

export default attendanceUI.reducer
